import { render, staticRenderFns } from "./ResidenceSelect.vue?vue&type=template&id=5cfcdeba&"
import script from "./ResidenceSelect.vue?vue&type=script&lang=js&"
export * from "./ResidenceSelect.vue?vue&type=script&lang=js&"
import style0 from "./ResidenceSelect.vue?vue&type=style&index=0&id=5cfcdeba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports